import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonType } from 'projects/ppb-shared-library/src/lib/models/button-config.model';
import { CustomValidators } from 'projects/ppb-shared-library/src/lib/services/form/custom-validators';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'ppb-password-reset',
  templateUrl: './ppb-password-reset.component.html',
  styleUrls: ['./ppb-password-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PpbPasswordResetComponent implements OnDestroy {

  loginForm: UntypedFormGroup;
  providedEmail: string;
  step: number = 1;

  isLoading$ = new BehaviorSubject(false);
  ButtonType = ButtonType;

  private subs = new Subscription();

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private userService: UserService,
    private cd: ChangeDetectorRef
  ) {
    this.providedEmail = this.router.getCurrentNavigation().extras?.state?.email;
    this.loginForm = this.fb.group({
      email: [this.providedEmail,
        { validators: [Validators.required, CustomValidators.email()] }
      ]
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  nextStep(step: number): void {
    switch (step) {
      case 2:
        const emailControl = this.loginForm.controls.email;
        emailControl.markAsTouched();
        emailControl.updateValueAndValidity();
        if (emailControl.valid) {
          emailControl.disable();
          this.passwordChangeEmailSend();
        }
        break;
      default:
        this.step = step;
        break;
    }
  }

  passwordChangeEmailSend(): void {
    this.isLoading$.next(true);
    this.subs.add(
      this.userService.passwordChangeEmailSend(this.loginForm.getRawValue().email)
        .subscribe(_ => {
            this.isLoading$.next(false);
            this.step = 2;
            this.cd.markForCheck();
          },
          _ => this.isLoading$.next(false))
    );
  }
}
